"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_CODE = exports.DEFAULT_SERVER_ERROR_MESSAGE = exports.CONNECTION_TIMED_OUT_ERROR_MESSAGE = exports.BODY_ENCODER = exports.METHOD = void 0;
require("rxjs");
require("../baseTypes");
var METHOD;
(function (METHOD) {
    METHOD["GET"] = "get";
    METHOD["POST"] = "post";
    METHOD["PATCH"] = "patch";
    METHOD["PUT"] = "put";
    METHOD["DELETE"] = "delete";
})(METHOD = exports.METHOD || (exports.METHOD = {}));
var BODY_ENCODER;
(function (BODY_ENCODER) {
    BODY_ENCODER[BODY_ENCODER["json"] = 0] = "json";
    BODY_ENCODER[BODY_ENCODER["formData"] = 1] = "formData";
})(BODY_ENCODER = exports.BODY_ENCODER || (exports.BODY_ENCODER = {}));
exports.CONNECTION_TIMED_OUT_ERROR_MESSAGE = 'connectionTimedOutError';
exports.DEFAULT_SERVER_ERROR_MESSAGE = 'serverError';
var ERROR_CODE;
(function (ERROR_CODE) {
    ERROR_CODE["AccessDenied"] = "AccessDenied";
    ERROR_CODE["ExpiredToken"] = "ExpiredToken";
    ERROR_CODE["InvalidToken"] = "InvalidToken";
    ERROR_CODE["InvalidURI"] = "InvalidURI";
    ERROR_CODE["MethodNotAllowed"] = "MethodNotAllowed";
    ERROR_CODE["NotFound"] = "NotFound";
    ERROR_CODE["NotImplemented"] = "NotImplemented";
    ERROR_CODE["ServiceUnavailable"] = "ServiceUnavailable";
    ERROR_CODE["UnexpectedContent"] = "UnexpectedContent";
    ERROR_CODE["UnknownError"] = "UnknownError";
})(ERROR_CODE = exports.ERROR_CODE || (exports.ERROR_CODE = {}));
//# sourceMappingURL=types.js.map